export default Object.freeze({
  ar: 'Arabic',
  en: 'English',
  fr: 'Français',
});
